import type { SupportedLocale } from '~~/types/message'

// 언어 선택 영속화에 사용하는 localStorage 키
const PREFERRED_LANGUAGE_KEY = 'preferredLanguage'

function isSupportedLocale(value: string): value is SupportedLocale {
  return value === 'ko' || value === 'en' || value === 'ja'
}

export function useLocalePreference() {
  // navigator.language 등 원시 언어 코드를 지원 언어(ko/en/ja)로 정규화
  function normalizeLocale(raw: string | null | undefined): SupportedLocale {
    const code = ((raw ?? '').trim().split('-')[0] ?? '').toLowerCase()

    if (isSupportedLocale(code))
      return code

    return 'ko'
  }

  // localStorage(preferredLanguage) → navigator.language → ko 순으로 초기 언어 결정
  function getInitialLocale(): SupportedLocale {
    if (typeof window === 'undefined')
      return 'ko'

    const stored = window.localStorage.getItem(PREFERRED_LANGUAGE_KEY)
    if (stored && isSupportedLocale(stored))
      return stored

    return normalizeLocale(window.navigator?.language)
  }

  function savePreferredLocale(locale: SupportedLocale) {
    if (typeof window === 'undefined')
      return

    window.localStorage.setItem(PREFERRED_LANGUAGE_KEY, locale)
  }

  return {
    normalizeLocale,
    getInitialLocale,
    savePreferredLocale,
  }
}
